(function (factory) {
  'use strict';

  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  window.FFCBundleTransducerSelector = api;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { api.initAll(document); });
  } else {
    api.initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { api.initAll(event.target); });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-ffc-bundle-transducer-selector]').forEach(function (root) {
      if (typeof root.ffcRestoreLinkedSelection === 'function') root.ffcRestoreLinkedSelection();
      else if (typeof root.ffcClearRequiredSelections === 'function') root.ffcClearRequiredSelections();
    });
  });
})(function () {
  'use strict';

  var TARGET_BUNDLE_IDS = new Set(['8250453622919', '8253625729159', '8263748485255']);
  var EXACT_LINK_BUNDLE_IDS = new Set(['8250453622919', '8253625729159']);
  var FORCED_VALUE = 'Digital Only';

  function valuesForDigitalVariant(values, forcedOptionPosition, forcedValue) {
    if (!Array.isArray(values)) return [];
    var position = Number(forcedOptionPosition);
    if (!Number.isInteger(position) || position < 1 || position > values.length) return [];
    var result = values.slice();
    result[position - 1] = forcedValue;
    return result;
  }

  function resolveDigitalVariant(variants, values, forcedOptionPosition, forcedValue) {
    var position = Number(forcedOptionPosition);
    if (!Array.isArray(variants) || !Array.isArray(values)) return null;
    if (!Number.isInteger(position) || position < 1 || position > values.length) return null;
    if (values.some(function (value) { return !value; })) return null;
    if (values[position - 1] !== forcedValue) return null;

    var matches = variants.filter(function (variant) {
      if (!Array.isArray(variant.options) || variant.options.length !== values.length) return false;
      if (variant.options[position - 1] !== forcedValue) return false;
      if (variant.requires_shipping !== false) return false;
      return variant.options.every(function (value, index) { return value === values[index]; });
    });
    if (matches.length !== 1) return null;
    return { variant: matches[0], available: Boolean(matches[0].available) };
  }

  function normalizeLinkedDigitalVariant(variants, linkedId, optionCount, forcedOptionPosition, forcedValue) {
    if (!linkedId || !Array.isArray(variants)) return null;
    var linkedVariant = variants.find(function (variant) { return String(variant.id) === String(linkedId); });
    if (!linkedVariant || !Array.isArray(linkedVariant.options) || linkedVariant.options.length !== Number(optionCount)) return null;
    var digitalValues = valuesForDigitalVariant(linkedVariant.options, forcedOptionPosition, forcedValue);
    var resolution = resolveDigitalVariant(variants, digitalValues, forcedOptionPosition, forcedValue);
    return resolution ? resolution.variant : null;
  }

  function parseVariants(section) {
    var source = section && section.querySelector('[data-variant-json]');
    if (!source) return [];
    try {
      var parsed = JSON.parse(source.value || source.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function optionPosition(control) {
    return Number(String(control.dataset.index || '').replace('option', '')) || 0;
  }

  function optionControls(root) {
    return Array.from(root.querySelectorAll('[data-variant-input]')).sort(function (left, right) {
      return optionPosition(left) - optionPosition(right);
    });
  }

  function syncGuideImage(select) {
    var field = select.closest('[data-ffc-transducer-field]');
    if (!field) return;
    var card = field.querySelector('[data-ffc-choice-card]');
    var media = field.querySelector('[data-ffc-guide-media]');
    var image = field.querySelector('[data-ffc-guide-image]');
    var selected = select.options[select.selectedIndex];
    var imageUrl = selected && select.value ? selected.dataset.ffcGuideImage : '';

    if (!card || !media || !image || !imageUrl) {
      if (media) media.hidden = true;
      if (image) {
        image.removeAttribute('src');
        image.alt = '';
      }
      if (card) card.classList.remove('is-selected');
      return;
    }

    image.src = imageUrl;
    image.alt = selected.dataset.ffcGuideAlt || selected.dataset.ffcGuideTitle || select.value;
    media.hidden = false;
    card.classList.add('is-selected');
  }

  function replaceVariantInUrl(variantId) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', String(variantId));
    window.history.replaceState({ path: url.toString() }, '', url.toString());
  }

  function removeVariantFromUrl() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('variant')) return;
    url.searchParams.delete('variant');
    window.history.replaceState({ path: url.toString() }, '', url.toString());
  }

  function initRoot(root) {
    if (root.dataset.ffcInitialized === 'true') return;

    var productId = String(root.dataset.productId || '');
    var templateSuffix = String(root.dataset.templateSuffix || '');
    var requiredCount = Number(root.dataset.requiredTransducerCount || 0);
    var optionCount = Number(root.dataset.optionCount || 0);
    var forcedOptionPosition = Number(root.dataset.digitalOptionPosition || 0);
    var isBundle = templateSuffix === 'bundles' && TARGET_BUNDLE_IDS.has(productId) && requiredCount > 0;
    var section = root.closest('.product-section');
    var form = section && (document.getElementById(root.dataset.formId) || section.querySelector('.product-single__form'));
    var addButton = form && form.querySelector('[data-add-to-cart]');
    var addButtonText = addButton && addButton.querySelector('[data-add-to-cart-text]');
    var masterSelect = form && form.querySelector('[data-product-select]');
    var requiredSelects = Array.from(root.querySelectorAll('[data-ffc-required-transducer]'));
    var forcedControls = Array.from(root.querySelectorAll('[data-ffc-forced-digital-option]'));
    var controls = optionControls(root);
    var status = root.querySelector('[data-ffc-bundle-status]');
    var variants = parseVariants(section);
    var unexpectedOption = root.querySelector('[data-ffc-unexpected-option], [data-ffc-invalid-option-contract]');
    var scopeValid = root.dataset.scopeValid === 'true' && root.dataset.digitalVariantValid === 'true';
    var structureValid = Boolean(
      isBundle
      && section
      && String(section.dataset.productId || '') === productId
      && form
      && addButton
      && addButtonText
      && masterSelect
      && scopeValid
      && !unexpectedOption
      && optionCount > 0
      && controls.length === optionCount
      && requiredSelects.length === requiredCount
      && forcedControls.length === 1
      && optionPosition(forcedControls[0]) === forcedOptionPosition
      && forcedControls[0].value === FORCED_VALUE
      && variants.length > 0
    );

    function setStatus(message) {
      if (!status) return;
      if (status.textContent.trim() !== message) status.textContent = message;
      status.classList.toggle('is-error', Boolean(message));
    }

    function setButton(disabled, text) {
      if (!addButton || !addButtonText) return;
      if (addButton.disabled !== disabled) addButton.disabled = disabled;
      addButton.classList.toggle('disabled', disabled);
      if (addButtonText.textContent.trim() !== text) addButtonText.textContent = text;
    }

    if (!structureValid) {
      if (masterSelect) masterSelect.value = '';
      if (form) form.dataset.ffcSelectionComplete = 'false';
      setButton(true, 'Unavailable');
      setStatus('Digital purchase options are unavailable. Please contact Fishfinder Coach.');
      return;
    }

    root.dataset.ffcInitialized = 'true';
    var defaultButtonText = addButtonText.dataset.defaultText || 'Add to cart';
    var chooseButtonText = requiredCount > 1 ? 'Choose your transducers' : 'Choose your transducer';
    var syncing = false;

    function selectedValues() {
      return controls.map(function (control) { return control.value; });
    }

    function currentState() {
      var firstMissing = requiredSelects.find(function (select) { return !select.value; });
      if (firstMissing) return { valid: false, reason: 'incomplete', firstMissing: firstMissing };
      var values = selectedValues();
      if (values.length !== optionCount || values.some(function (value) { return !value; })) {
        return { valid: false, reason: 'incomplete' };
      }
      var resolution = resolveDigitalVariant(variants, values, forcedOptionPosition, FORCED_VALUE);
      if (!resolution) return { valid: false, reason: 'unavailable' };
      var masterOption = Array.from(masterSelect.options).find(function (option) {
        return String(option.value) === String(resolution.variant.id);
      });
      if (!masterOption) return { valid: false, reason: 'unavailable' };
      if (!resolution.available) return { valid: false, reason: 'sold-out', variant: resolution.variant };
      return { valid: true, reason: 'resolved', variant: resolution.variant };
    }

    function applyState(updateHistory) {
      if (syncing) return currentState();
      syncing = true;
      requiredSelects.forEach(syncGuideImage);
      var state = currentState();
      form.dataset.ffcSelectionComplete = state.valid ? 'true' : 'false';
      root.classList.toggle('is-complete', state.valid);

      if (state.valid) {
        masterSelect.value = String(state.variant.id);
        setButton(false, defaultButtonText);
        setStatus('');
        if (updateHistory) replaceVariantInUrl(state.variant.id);
      } else if (state.reason === 'sold-out') {
        masterSelect.value = String(state.variant.id);
        setButton(true, (window.theme && window.theme.strings && window.theme.strings.soldOut) || 'Sold out');
        setStatus('This digital option is sold out.');
        if (updateHistory) replaceVariantInUrl(state.variant.id);
      } else if (state.reason === 'unavailable') {
        masterSelect.value = '';
        setButton(true, 'Unavailable');
        setStatus('That digital option is unavailable. Please choose again.');
        if (updateHistory) removeVariantFromUrl();
      } else {
        masterSelect.value = '';
        setButton(true, chooseButtonText);
        setStatus('');
      }

      syncing = false;
      return state;
    }

    requiredSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        window.setTimeout(function () { applyState(true); }, 0);
      });
    });

    section.addEventListener('variantChange', function () {
      window.setTimeout(function () { applyState(false); }, 0);
    });

    form.addEventListener('submit', function (event) {
      var state = applyState(false);
      if (state.valid && String(masterSelect.value) === String(state.variant.id)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (state.firstMissing) {
        state.firstMissing.focus();
        state.firstMissing.reportValidity();
      } else {
        addButton.focus();
      }
    }, true);

    var observer = new MutationObserver(function () {
      if (form.dataset.ffcSelectionComplete !== 'true' && !syncing) applyState(false);
    });
    observer.observe(addButton, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });

    function clearRequiredSelections() {
      requiredSelects.forEach(function (select) {
        select.selectedIndex = 0;
        select.value = '';
      });
      return applyState(false);
    }

    function applyLinkedDigitalVariant(linkedVariant) {
      if (!linkedVariant || !EXACT_LINK_BUNDLE_IDS.has(productId)) return false;
      var assignments = requiredSelects.map(function (select) {
        var position = optionPosition(select);
        var value = linkedVariant.options[position - 1];
        var matchingOption = Array.from(select.options).find(function (option) {
          return option.value === value && !option.disabled;
        });
        return matchingOption ? { select: select, value: value } : null;
      });
      if (assignments.some(function (assignment) { return !assignment; })) return false;
      assignments.forEach(function (assignment) { assignment.select.value = assignment.value; });
      var state = applyState(false);
      return Boolean(state.valid && String(state.variant.id) === String(linkedVariant.id));
    }

    function restoreLinkedSelection() {
      var linkedId = new URLSearchParams(window.location.search).get('variant');
      var linkedDigitalVariant = normalizeLinkedDigitalVariant(
        variants,
        linkedId,
        optionCount,
        forcedOptionPosition,
        FORCED_VALUE
      );
      if (linkedDigitalVariant) {
        replaceVariantInUrl(linkedDigitalVariant.id);
        if (applyLinkedDigitalVariant(linkedDigitalVariant)) return;
      } else if (linkedId) {
        removeVariantFromUrl();
      }
      clearRequiredSelections();
    }

    restoreLinkedSelection();

    root.ffcApplyDigitalState = applyState;
    root.ffcClearRequiredSelections = clearRequiredSelections;
    root.ffcRestoreLinkedSelection = restoreLinkedSelection;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ffc-bundle-transducer-selector]').forEach(initRoot);
  }

  return {
    initAll: initAll,
    normalizeLinkedDigitalVariant: normalizeLinkedDigitalVariant,
    resolveDigitalVariant: resolveDigitalVariant,
    valuesForDigitalVariant: valuesForDigitalVariant
  };
});
